import React from "react";

const Loader = () => {
  return (
    <div className="flex items-center justify-center space-x-2">
      <div className="h-3 w-3 animate-dots rounded-full bg-blue-600"></div>
      <div
        className="h-3 w-3 animate-dots rounded-full bg-blue-600"
        style={{ animationDelay: "0.2s" }}
      ></div>
      <div
        className="h-3 w-3 animate-dots rounded-full bg-blue-600"
        style={{ animationDelay: "0.4s" }}
      ></div>
    </div>
  );
};

export default Loader;
